import type { ProductConfig } from "@web/config"

export class ThemeManager {
  private static instance: ThemeManager
  private currentConfig: ProductConfig | null = null

  private constructor() { }

  static getInstance(): ThemeManager {
    if (!ThemeManager.instance) {
      ThemeManager.instance = new ThemeManager()
    }
    return ThemeManager.instance
  }

  applyTheme(config: ProductConfig): void {
    this.currentConfig = config
    const root = document.documentElement

    // Apply CSS custom properties if available
    if (config.theme.colors.cssVariables) {
      Object.entries(config.theme.colors.cssVariables).forEach(([property, value]) => {
        root.style.setProperty(property, value)
      })
    }

    // Add product-specific class for additional styling
    root.className = root.className.replace(/product-\w+/g, "")
    // root.classList.add(`product-${config.product.domain.split(".")[0]}`)
  }

  resetTheme(): void {
    const root = document.documentElement

    if (this.currentConfig?.theme.colors.cssVariables) {
      Object.keys(this.currentConfig.theme.colors.cssVariables).forEach((property) => {
        root.style.removeProperty(property)
      })
    }

    root.className = root.className.replace(/product-\w+/g, "")
    this.currentConfig = null
  }

  getCurrentConfig(): ProductConfig | null {
    return this.currentConfig
  }

  getFallbackClasses(): Record<string, string> {
    return this.currentConfig?.theme.colors.fallback || {}
  }
}

export const themeManager = ThemeManager.getInstance()
